<script lang="ts">
    import type ServiceProvider from "../providers/service.provider";
    import type { IStatistics } from "../services/survey-statistics.service";
    import { inflect } from '../../../core/helpers/string.helper'

    export let serviceProvider: ServiceProvider;

    let statistics: IStatistics = null;
    let processing: boolean = false;
    let error: boolean = false;

    serviceProvider.statisticsService.statisticsSubs.subscribe(
        (data) => (statistics = data)
    );

    serviceProvider.statisticsService.processingStatisticsSubs.subscribe(
        (status) => (processing = status)
    );

    serviceProvider.statisticsService.errorStatisticsSubs.subscribe(
        (status) => (error = status)
    );
</script>

{#if processing}
    <p>Načítám...</p>
{:else if statistics}
    <ul class="bno-statsbar">
        <li class="bno-statsbar__item" title="{inflect('probihajicichAnket', statistics.aktivni)}">
            <span class="bno-statsbar__num">{statistics.aktivni}</span>
            <p>
                <strong>{inflect('probihajicichAnket', statistics.aktivni)}</strong>
            </p>
        </li>
        <li class="bno-statsbar__item" title="{inflect('letosUkoncenychAnket', statistics.letosUzavrene)}">
            <span class="bno-statsbar__num">{statistics.letosUzavrene}</span>
            <p>
                <strong>{inflect('letosUkoncenychAnket', statistics.letosUzavrene)}</strong>
            </p>
        </li>
        <li class="bno-statsbar__item" title="{inflect('anketCelkem', statistics.celkem)}">
            <span class="bno-statsbar__num">{statistics.celkem}</span>
            <p>
                <strong>{inflect('anketCelkem', statistics.celkem)}</strong>
            </p>
        </li>
        <li class="bno-statsbar__item" title="{inflect('respondentu', statistics.respondenti)}">
            <span class="bno-statsbar__num">{statistics.respondenti}</span>
            <p>
                <strong>{inflect('respondentu', statistics.respondenti)}</strong>
            </p>
        </li>
    </ul>
{/if}
